import { UserRoleActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  master_data: [],
  userRolesList: null,
  userRoleDetails: null,
  deleted_userRole: null,
  saved_userRole: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case UserRoleActionTypes.get_userRolesList.REQUEST:
    return {
      ...state,
      loading: true,
      userRolesList: null,
    };
  case UserRoleActionTypes.get_userRolesList.SUCCESS:
    return {
      ...state,
      loading: false,
      userRolesList: payload,
    };
  case UserRoleActionTypes.get_userRoleDetails.REQUEST:
    return {
      ...state,
      loading: true,
      userRoleDetails: null,
    };
  case UserRoleActionTypes.get_userRoleDetails.SUCCESS:
    return {
      ...state,
      loading: false,
      userRoleDetails: payload,
    };
  case UserRoleActionTypes.delete_userRole.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_userRole: null,
    };
  case UserRoleActionTypes.delete_userRole.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_userRole: payload,
    };
  case UserRoleActionTypes.post_userRole.REQUEST:
    return {
      ...state,
      loading: true,
      saved_userRole: null,
    };
  case UserRoleActionTypes.post_userRole.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_userRole: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/userRoles/reducers/UserRoleReducer.js